__turbopack_context__.v({
  "fullDimensions": "benefitIcons-module-scss-module__Le5Guq__fullDimensions",
});
